/* eslint-disable id-length */
import React from 'react';
import {
  string,
  shape as shapeType,
  func,
  arrayOf as arrayOfType,
  number,
  bool
} from 'prop-types';
import { Button } from '@thd-olt-component-react/core-ui';
import { useDrawer } from '@thd-olt-component-react/drawer';
import { ProductInfo } from '../shared/ProductInfo';
import { Quotes } from '../shared/Quotes';
import { DELIMITER, DRAWERS } from '../shared/Constants';

import * as drawerStyles from '../shared/drawers.module.scss';
import * as styles from './add-to-quote-drawer.module.scss';

export const AddToQuoteDrawer = ({
  productLabel,
  brandName,
  mainImage,
  quoteList,
  setSelectedQuote,
  selectedQuote,
  showLoadMore,
  quotesPageSize,
  setQuotesPageSize
}) => {

  const selectQuote = (e) => {
    const { value } = e?.target;
    const [quoteId, userId, quoteName] = value.split(DELIMITER);
    setSelectedQuote({
      userId,
      quoteId,
      quoteName
    });
  };
  const { setCurrentDrawer, closeDrawer } = useDrawer();

  const createNewQuoteClick = () => {
    setCurrentDrawer(DRAWERS.CREATE_QUOTE);
    window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.createAQuoteOverlay');
  };

  return (
    <>
      <div className={`${styles.addToQuote} ${drawerStyles.container}`}>
        <div className={`${styles.addToQuote} ${drawerStyles.content}`}>
          <ProductInfo productLabel={productLabel} brandName={brandName} mainImage={mainImage} />
          <hr className={drawerStyles.divider} />
          <Button
            contentClass={`${styles.addToQuote} ${styles.createQuote__button} ${styles.quote__button}`}
            link
            onClick={createNewQuoteClick}
          >
            Create New Quote
          </Button>
          <p className={styles.separator__text}>
            -or-
          </p>
          <h3>Add to an Existing Quote:</h3>
          <Quotes
            quoteList={quoteList}
            selectedQuote={selectedQuote}
            selectQuote={selectQuote}
            showLoadMore={showLoadMore}
            quotesPageSize={quotesPageSize}
            setQuotesPageSize={setQuotesPageSize}
          />
        </div>
        <div className={`${styles.addToQuote} ${drawerStyles.footer}`}>
          <Button
            disabled={!selectedQuote?.quoteId.length}
            onClick={() => setCurrentDrawer(DRAWERS.PRICE_CHANGE_WARNING)}
          >
            Add to Quote
          </Button>
          <Button outline onClick={closeDrawer}>Cancel</Button>
        </div>
      </div>
    </>
  );
};

AddToQuoteDrawer.propTypes = {
  productLabel: string.isRequired,
  brandName: string,
  mainImage: shapeType({
    url: string.isRequired,
    alt: string
  }),
  quoteList: arrayOfType(shapeType({
    name: string
  })),
  setSelectedQuote: func.isRequired,
  selectedQuote: shapeType({
    quoteId: string.isRequired,
    quoteName: string.isRequired,
    userId: string.isRequired
  }).isRequired,
  showLoadMore: bool.isRequired,
  quotesPageSize: number.isRequired,
  setQuotesPageSize: func.isRequired
};

AddToQuoteDrawer.defaultProps = {
  brandName: null,
  quoteList: [],
  mainImage: {
    alt: ''
  },
};
